<i18n>
{
  "fr": {
    "error-detail": "Détail de l'erreur",
    "return-home": "Retour à l'accueil",
    "restart-search": "Relancer la recherche",
    "send-to-amplitudes": "Envoyer l'erreur à Amplitudes",
    "send-to-amplitudes-title": "En cliquant sur \"Envoyer\", nous vous proposons de transmettre automatiquement les traces informatiques au service technique Amplitudes afin qu'il puisse analyser et corriger au plus vite le dysfonctionnement.",
    "send-to-amplitudes-plhold": "Vous pouvez ajouter un message pour nous aider d'avantage !",
    "send-to-amplitudes-success": "Votre message a bien été envoyé!",
    "send-to-amplitudes-error": "Une erreur s'est produite !",
    "send": "Envoyer",
    "cancel": "Annuler",
    "title": "Erreur",
    "message": {
      "error": {
        "400": "Merci de relancer la recherche",
        "couple": "Le couple aller-retour sélectionné n'est pas réservable, veuillez relancer la recherche.",
        "pending-order": "Le bénéficiaire principal a déjà une commande en cours, celle-ci doit être fermée."
      }
    }
  },
  "en": {
    "error-detail": "Error detail",
    "return-home": "Home page",
    "restart-search": "Restart search",
    "send-to-amplitudes": "Send error to Amplitudes",
    "send-to-amplitudes-title": "By clicking on \"Send\", you can automatically send the computer traces to the Amplitudes technical department so that it can analyse and correct the malfunction as quickly as possible.",
    "send-to-amplitudes-success": "Your message has been sent !",
    "send-to-amplitudes-error": "An error has occurred !",
    "send-to-amplitudes-plhold": "You can add a message to help us !",
    "send": "Send",
    "cancel": "Cancel",
    "title": "Error",
    "message": {
      "error": {
        "400": "Please, restart your search",
        "couple": "The selected round trip couple is not bookable, please restart the search.",
        "pending-order": "The main beneficiary already has a pending order, this one has to be closed"
      }
    }
  }
}
</i18n>

<template>
  <v-dialog
    id="error-card"
    v-model="shown"
    persistent
    :max-width="error.response || error.error_description ? '520px' : '520px'"
    scrollable
  >
    <v-card
      color="error"
      dark
    >
      <v-card-title>{{ $i18n.t('title') }}</v-card-title>
      <v-card-text>
        <p v-if="error.error && error.error === 'od_has_command'">
          {{ $i18n.t('message.error.pending-order') }}
        </p>
        <p v-else>
          {{ $i18n.t('message.error.400') }}
        </p>
        <v-row>
          <v-btn
            @click="returnHome"
          >
            {{ $t('return-home') }}
          </v-btn>
        </v-row>
        <v-row class="mt-4">
          <v-btn
            v-if="flightStep !== '1'"
            @click="restartSearch"
          >
            {{ $t('restart-search') }}
          </v-btn>
        </v-row>
        <v-row class="mt-4">
          <v-btn
            v-if="true || (error.response || error.error_description && !(error.error && error.error === 'od_has_command'))"
            :disabled="submitDone"
            @click="sendToAmplitudes"
          >
            {{ $t('send-to-amplitudes') }}
          </v-btn>
        </v-row>
        <v-row
          v-if="!showMessage && (error.response || error.error_description && !(error.error && error.error === 'od_has_command'))"
          class="mt-4"
        >
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t('error-detail') }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <pre><code>{{ error.response || error }}</code></pre>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panels />
          </v-expansion-panels>
        </v-row>
        <v-row
          v-if="showMessage"
          class="mt-4"
        >
          <v-col cols="12">
            <label><b>{{ $t('send-to-amplitudes-title') }}</b></label>
          </v-col>
          <v-col cols="12">
            <textarea
              v-model="messageFromCustomer"
              :placeholder="$t('send-to-amplitudes-plhold')"
              class="error-tarea"
              rows="4"
            />
          </v-col>
          <v-col
            cols="3"
          >
            <v-btn
              @click="cancelError"
            >
              {{ $t('cancel') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="text-center"
          >
            <span
              v-if="submitDone && submitMsgSuccess"
              class="color-success"
            >{{ $t('send-to-amplitudes-success') }}</span>
            <span
              v-if="submitDone && submitMsgError"
              class="color-error"
            >{{ $t('send-to-amplitudes-error') }}</span>
          </v-col>
          <v-col
            cols="3"
          >
            <v-btn
              :disabled="submitDone"
              :loading="submitLoading"
              @click="submitError"
            >
              {{ $t('send') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import globalMixin from '@/mixins/global'
import _ from 'lodash'
import flightService from '@/services/flightService'

export default {
  name: 'ErrorParserAlert',
  mixins: [globalMixin],
  props: {
    error: {
      type: [Object, Error, String],
      required: true
    }
  },
  data: () => ({
    shown: true,
    showMessage: false,
    submitLoading: false,
    submitDone: false,
    submitMsgSuccess: false,
    submitMsgError: false,
    messageFromCustomer: '',
    title: '',
    message: ''
  }),
  computed: {
    ...mapState({
      flightStep: state => state.fb.step,
      stateError: state => state.general.error
    })
  },
  // created () {
  //   this.parseError(this.error)
  // },
  methods: {
    ...mapActions({
      returnHomeAction: 'general/returnHome',
      flightSearchAction: 'fb/flightSearchAction'
    }),
    ...mapMutations({
      changeError: 'general/changeError'
    }),
    /**
     * This method call to store action returnHome to reset all store state to default
     * except the search parameters and reset error state
     * @return {undefined}
     */
    returnHome () {
      this.routerPushHome()
      this.changeError(undefined)
      this.returnHomeAction()
    },
    /**
     * @return {undefined}
     */
    restartSearch () {
      this.routerPushHome()
      this.changeError(undefined)
      this.flightSearchAction()
    },
    sendToAmplitudes () {
      this.showMessage = true
    },
    cancelError () {
      this.showMessage = false
    },
    async submitError () {
      this.submitLoading = true

      // Have to do this because the backend is too dumb to process a non required field
      let phonePersonal = this.$store.state.fb.passengersInformation.mobilePhoneNumber
      if (_.isEmpty(this.$store.state.fb.passengersInformation.phoneNumber)) {
        phonePersonal = this.$store.state.fb.passengersInformation.mobilePhoneNumber
      } else {
        phonePersonal = this.$store.state.fb.passengersInformation.phoneNumber
      }

      const customer = _.cloneDeep(this.$store.state.general.customer)

      customer.civility = this.$store.state.general.customer.civility
      customer.first_name = this.$store.state.general.customer.first_name
      customer.last_name = this.$store.state.general.customer.last_name
      customer.birthday = this.$store.state.general.customer.birthday
      customer.street_1 = this.$store.state.fb.passengersInformation.contactAddress
      customer.city = this.$store.state.fb.passengersInformation.contactCity
      customer.zip_code = this.$store.state.fb.passengersInformation.contactZipCode
      customer.country_code = this.$store.state.fb.passengersInformation.contactCountry.alpha_2_code
      customer.email = this.$store.state.fb.passengersInformation.contactEmail
      customer.phone_mobile = this.$store.state.fb.passengersInformation.mobilePhoneNumber
      customer.registration_number = this.$store.state.general.customer.registration_number
      customer.phone_personnal = phonePersonal

      let msgErr = ''
      console.log('SSSSS', this.error)
      // eslint-disable-next-line no-mixed-operators
      if (this.error.response || this.error.error_description && !(this.error.error && this.error.error === 'od_has_command')) {
        msgErr = this.error.response || this.error
      }

      // Service call
      try {
        await flightService.sendErrorToAmplitudes({
          customer,
          travellers: this.$store.state.fb.passengersInformation.selectedTravellersDetails,
          luggageOptionsPerTrip: this.$store.state.fb.booking.luggageOptionsPerTrip,
          errorMsg: msgErr,
          manualMsg: this.messageFromCustomer,
          bookingIdentifier: this.$store.state.fb.booking.bookingIdentifier,
          selectedItinerary: this.$store.state.fb.searchResults.selectedItinerary
        })

        this.submitLoading = false
        this.submitMsgSuccess = true
        this.submitDone = true
      } catch (error) {
        this.submitDone = true
        this.submitLoading = false
        this.submitMsgError = true
      }
    }
    // /**
    //  * Should parse error based on http error codes and error description
    //  * @return {boolean}
    //  */
    // parseError () {
    //   this.title = this.$i18n.t('title.error.400')
    //   let localeMessages = this.$i18n.t(`message.error.${this.stateError}`)
    //   if (localeMessages.startsWith('message.error.')) {
    //     localeMessages = this.$i18n.t('message.error.400')
    //   }
    //   this.message = localeMessages
    // }
  }
}
</script>

<style scoped>
::v-deep .v-expansion-panel-content__wrap {
  overflow-y: auto !important;
}

::v-deep .v-expansion-panel {
  background-color: #272727 !important;
  color: #FFFFFF;

}

code {
  background-color: #272727;
  color: #FFFFFF;
}

.error-tarea {
  background-color: #FFFFFF;
  width: 100%;
  padding: 4px;
}

.color-success {
  color: green;
}

.color-error {
  color: black;
}
</style>
